module.exports = {
  language: {
    name: '簡體中文',
    title: '選擇語言',
    subList: [
      {
        name: 'English',
        link: 'en',
      },
      // {
      //   name: '简体中文',
      //   link: 'zh',
      // },
      {
          name: '繁體中文',
          link: 'tw',
      },
      {
        name: '日本語',
        link: 'jp',
      },
      {
        name: '한국어',
        link: 'kr',
      },
      {
        name: 'ไทย',
        link: 'th',
      },
      {
        name: 'Tiếng Việt',
        link: 'vn',
      },
      {
        name: 'Español',
        link: 'es',
      },
    ]
  },
  "user":{//我的
    "wdtd": "我的團隊",
    "wdyj": "我的業績",
    "ren": "人",
  },
  "kjsy":{
    "title": "收益",
    "fxsy": "分享收益",
    "zjlsl": "總獎勵數量：",
    "jl": "獎勵",
    "sj": "日期",
    "sl": "數量",
    "sm": "說明"
  },
  pay:{//購買
    title: '購買礦機',
    gmsl: '購買數量',
    zf: '支付',
    kyye: '可用餘額',
    kyyebz: '可用餘額不足',
    bztbtips: '輸入的提幣數量小於該幣種最低提幣要求',
    bztbtips2: '提幣數量不能低於最低提幣',
    qsrjymm: '請輸入6位交易密碼',
    wxts: '溫馨提示',
  },
  chongbi:{
    title: '充幣',
    lianmc: '鏈類型',
    scl: '生成專屬鏈',
    sy: '私鑰',
    ewm: '二維碼',
    bcewm: '保存二維碼',
    cbdz: '充幣地址',
    fz: '複製',
    sl: '充幣數量',
    qsrsl: '請輸入充幣數量',
    sjczje: '實際充值金額',
    qsrsjczje: '請輸入實際充值金額',
    pzms: '憑證描述',
    qsrms: '請輸入描述',
    hxz: '哈希值',
    qsrhxz: '請輸入哈希值',
    pztp: '憑證圖片',
    qscpztp: '請上傳憑證圖片',
    fzcg: '複製成功',
    yhkcz: '銀行卡充值',
    usdtcz: 'USDT充值',
    btccz: 'BTC充值',
    xzbz: '選擇幣種',
    sure: '確認',
    ck: '查看',
    "tips1": "請勿向上述地址充值任何非本幣種資產否則資產不可找回",
    "tips2": "1.錢包/平臺的兼容：即對該網絡支持；如目標平臺不支持您的提幣網絡，將導致資產無法找回。",
    "tips3": "2.您充值網絡和目標平臺是一致的；如您選擇了目標地址是以太坊網絡，但充值選擇了TRC20智能鏈，您或將無法找回您的數字資產。",
    "tips4": "3.充值前確保您的地址、金額正確。",
    "tips5": "溫馨提示：由於區塊網絡匿名和私密，一旦輸入錯誤信息，您將損失對應資產。請務必仔細核對您的充值地址及數量"
  },
  usdttb:{
    title: '提幣',
    lmc: '鏈類型',
    xzl: '選擇鏈',
    xztbdz: '選擇提幣地址',
    qsrtbdz: '請輸入提幣地址',
    tbdz: '提幣地址',
    qsrdz: '請輸入地址',
    tbsl: '提幣數量',
    tbsl2: '提幣數量：',
    qsrtbsl: '請輸入提幣數量',
    sjtxje: '實際提現金額',
    qsrsjtxje: '請輸入實際提現金額',
    dzje:'到賬金額',
    jymm: '交易密碼',
    qsrjymm: '請輸入交易密碼',
    sxf: '手續費',
    qsrsxf: '請輸入手續費',
    dzsl: '到賬數量',
    dzsl2: '到賬數量：',
    qsrdzsl: '請輸入到賬數量',
    wxts: '溫馨提示：',
    mrzdtxcs: '每次最低提幣數量：',
    hxxf: '還需消費',
    cktx: '才可提現',
    ci: '次',
    wddtxyq: '未達到提現要求',
    tjcg: '提交成功，請等待審核',
    tips: '自身算力需大於1T（體驗礦機算力除外）或者傘下算力大於50T方可提幣。 ',
    dz: '地址',
    qd: '確定',
    "zdtb": "最低提幣"
  },
  kefu:{
    title:'聯繫客服',
    zxkf:'聯繫客服',
    fzcg:'複製成功'
  },
  xgdlmm:{//修改登錄密碼
    title:'修改登錄密碼',
    t1:'當前登錄密碼',
    t2:'請輸入當前登錄密碼',
    t3:'新密碼',
    t4:'請輸入6-16位數字和字母',
    t5:'確認密碼',
    t6:'請輸入6-16位數字和字母',
    t7:'確認',
    t8:'密碼跟確認密碼不一致'
  },
  sztxmm:{//設置提現密碼
    title:'修改交易密碼',
    wjtkmm: '忘記交易密碼',
    qsrjdlmm:'請輸入當前交易密碼',
    zh: '賬號',
    qsryxhzsj: '請輸入郵箱或者手機',
    t1:'當前交易密碼',
    t2:'新交易密碼',
    t3:'請輸入6位交易密碼',
    t4:'確認密碼',
    t5:'忘記交易密碼？ ',
    t6:'確認',
    t7:'密碼跟確認密碼不一致',
    t8:'交易密碼',
    yzm: '驗證碼',
    qsryzm: '請輸入驗證碼',
    hqyzm: '獲取驗證碼'
  },
  record: {
    cbjl: '充幣記錄',
    tbjl: '提幣記錄',
    status:['未審核','已通過','已駁回'],
    bhly: '駁回理由',
    ldz: '地址：',
    cjsj: '創建時間：',
    zzsj: '轉賬時間：',
    czl: '充值鏈：',
    zrl: '轉入鏈：',
    jyhx: '交易哈希：'
  },
  yqm: {
    wdyqlj: '我的邀請鏈接',
    wdyqm: '我的邀請碼',
    schbyq: '生成海報邀請',
    bctp: '保存圖片',
    qx: '取消',
    fx: '分享',
    yqm: '複製邀請碼',
    bcewmdxc: '保存二維碼到相冊',
    bcbd: '保存本地'
  },
  "wdtd": {
    title: '我的團隊',
    td: '的團隊',
    yqhy: '邀請好友',
    ren: '人',
    wdtdzrs: '我的團隊總人數',
    uid: 'UID：',
    zh: '賬號：',
    tdrs: '團隊人數：',
    zcsj: '註冊日期：'
  },
  "wdyj": {
    title: '我的業績',
    wdyd: '我的一代',
    dyj: '的業績',
    tdzyj: '團隊總業績',
    uid: 'UID：',
    tdrs: '團隊人數：',
    yj: '業績：'
  },
  "zc": {
    title: '資產',
    zzczh: '總資產折合',
    dh: '兌換',
    yczc: '隱藏為0的資產',
    xj: '現價',
    zh: '折合 ',
    zcmx: '資產明細',
  },
  "duihuang": {
    title: '兌換',
    hl: '匯率',
    zf: '支付',
    qbdh: '全部兌換',
    ky: '可用',
    dd: '得到',
    ljdh: '立即兌換',
    cont: '匯率變動，以實際到賬數額為準',
    yebz: '餘額不足',
    ksslbz: '可賣數量不足',
    qtxje: '請輸入數量',
    dhcg: '兌換成功',
    mrcg: '買入成功',
    mccg: '賣出成功',
    wtcg: '委託成功',
    ts: '提示',
    btcmTips: '根據智能合約設定，GDCC兌換USDT將於2023年8月8日啟動。 ',
    qx: '取消'
  },
  "sign":{
    "title": '簽到領幣',
    "title2": '每日簽到獎勵',
    "title3": '簽到獎勵',
    "qd": '簽到',
    "yqd": '已簽到',
    "hdgz": '活動規則',
    "qdjl": '簽到記錄',
    "qdcg": '簽到成功'
  },
  "langNew": {
    "wd": "我的",
    "jd": "借貸",
    "jghy": "期貨",
    "xbsg": "新幣申購",
    "sylx": "收益類型",
    "syts": "收益天數：",
    "rsy": "日收益：",
    "rsy2": "日收益",
    "yjdts": "已借貸天數：",
    "jdsy": "借貸收益：",
    "jdsy2": "借貸收益",
    "jdrq": "借貸日期：",
    "qdsy": "簽到收益",
    "tgsy": "推廣收益",
    "sybl": "收益比例",
    "sybl2": "收益比例：",
    "ljcy": "立即參與",
    "zsy": "總收益",
    "jdrz": "節點認證",
    "jiedian": "節點",
    "qsrje": "請輸入節點",
    "xyb": "下一步",
    "zhye": "賬戶餘額",
    "dzye": "地址餘額",
    "zhyezh": "賬戶餘額(折合)",
    "zq": "週期：",
    "zq2":"週期",
    "jdsl": "借貸數量",
    "yxbd": "郵箱綁定",
    "qsryxzh": "請輸入郵箱賬號",
    "yxgz": "輸入的郵箱不符合規則",
    "jxz": "進行中",
    "ywc": "已完成",
    "day": "天",
    "jg": "價格：",
    "zwsj": "暫無數據~",
    "wyjb": "我要藉幣",
    "fxjl": "分享獎勵",
    "aqsz": "安全設置",
    "wded": "我的二代",
    "wdsd": "我的三代",
    "dbxe": "單筆限額",
    "tjdd": "提交訂單",
    "tqsh": "提取贖回：",
    "shuhui": "贖回",
    "ljdz": "鏈接地址",
    "yyqh": "語言切換",
    "zxkf": "在線客服",
    "syl": "收益率",
    "zhuanbi": "賺幣",
    "zbsy": "賺幣收益",
    "mc": "名稱",
    "zxj": "最新價",
    "zfb": "漲幅榜",
    "shouye": "首頁",
    "gg": "公告",
    "rzz": "認證中",
    "yrz": "已認證",
    "rzsb": "認證不通過，請重新認證",
    "cxrz": "重新認證",
    "jymmts": "請到安全設置設置交易密碼"
  },
  "xbsg":{
    "title": "新幣申購",
    "wdsg": "我的申購",
    "scts": "鎖倉天數：",
    "sy": "剩餘",
    "ljsg": "立即申購",
    "ysk": "已售空",
    "xzjdy": "現在就訂閱",
    "dy": "訂閱",
    "fxjg": "發行價格",
    "fxl": "發行量",
    "ssrq": "上市日期",
    "yxqx": "有效期限",
    "qsrsl": "請輸入數量",
    "syl": "剩餘量",
    "sgrq": "申購日期",
    "sgsl": "申購數量",
    "bz": "幣種",
    "yebz": "USDT餘額不足",
    "tgsl": "通過數量",
    "shz": "審核中",
    "wtg": "未通過",
    "ytg": "已通過"
  },
  "wydb":{
    "title": "我要貸幣",
    "db": "貸幣",
    "dbz": "貸幣中",
    "jl": "記錄",
    "jdzq": "借貸周期(天)",
    "qhk": "去還款",
    "ljdb": "累計貸幣",
    "dhkbs" :"待還款筆數",
    "jkje": "借款金額",
    "qsrje": "請輸入金額",
    "rll": "日利率",
    "hkfs": "還款方式",
    "dqych": "到期一次還本息",
    "lx": "利息",
    "fkjg": "放款機構",
    "tpsc": "信用貸款(圖片上傳)",
    "fwxx": "房屋信息",
    "srzm": "收入證明(雇傭關系)",
    "yhmx": "銀行明細",
    "zjz": "證件照",
    "yd": "本人已閱讀並同意",
    "xy": "申請貸幣協議",
    "sqdb": "點擊申請貸幣",
    "gb": "關閉",
    "qd": "確定",
    "ts": "請勾選申請貸幣協議",
    "dbjl": "貸幣記錄",
    "hkhth": "貸款合同號",
    "wsh": "未審核",
    "yfk": "已放款",
    "sqrq": "申請日期",
    "zq": "周期",
    "dbsl": "貸幣數量",
    "zhke": "總還款額",
    "yhkxq": "應還款詳情",
    "bqyhk": "本期應還款（USDT）",
    "hktips": "請確保余額充足，余額不足請先充值再還款",
    "bj": "本金",
    "jie": "借",
    "ljhk": "立即還款",
    "qcz": "去充值",
    "yebzqxcz": "余額不足，請先充值再還款",
    "znj": "滯納金",
    "yqts": "逾期天數"
  },
  "hkxq":{
    "dd":"訂單",
    "fzhkdz":"復製還款地址",
    "hkxq": "還款詳情",
    "zlx": "總利息",
    "zhk": "總還款",
    "hkjg": "還款機構",
    "qschkpz": "請上傳還款憑證",
    "hkpz": "還款憑證"
  },
  "kxt":{
    "gao":"高",
    "di":"低",
    "wtgd":"委託掛單",
    "cj":"成交",
    "jj":"簡介",
    "sj":"時間",
    "fx":"方向",
    "jg":"價格",
    "sl":"數量",
    "mr":"買入",
    "mc":"賣出",
    "mp":"買盤",
    "sp":"賣盤",
    "slb":"數量",
    "fhsj":"發行時間",
    "fhsl":"發行數量",
    "bps":"白皮書",
    "gw":"官網",
    "fz":"min",
    "xs":"hour",
    "tian":"day",
    "zhou":"week",
    "yue":"月",
    "gd":"more",
    "ft":"副圖",
    "zt":"主圖",
    "sdt":"深度圖",
    "zx":"自選",
    "djck": "點擊查看"
  },
  "jghy":{
    "jghy": "期貨",
    "yxhy": "永續合約",
    "mz": "買漲",
    "md": "買跌",
    "gmj": "購買價",
    "jsj": "結算價",
    "xj": "現價",
    "fx": "方向",
    "sl": "數量",
    "jgsj": "交割時間",
    "gb": "關閉",
    "jxxd": "繼續下單",
    "cclb": "持倉列表",
    "zc": "在持",
    "lscc": "歷史持倉",
    "qblx": "全部類型",
    "yk": "盈虧",
    "ddqr": "訂單確認",
    "dqsj": "到期時間",
    "jssj": "結算時間",
    "sy": "收益",
    "tzje": "投資金額",
    "zdje": "投資金額大於0",
    "kyye": "可用餘額",
    "kyye2": "可用餘額：",
    "sxf": "手續費：",
    "sxfl": "手續費",
    "jypz": "名稱",
    "jyfx": "交易方向",
    "qrxd": "確認下單",
    "fs": "more",
    "dqye": "當前餘額"
  },
  "zhjl":{
    "title": "賬戶記錄",
    "cbtb":"充幣提幣",
    "jymx":"交易明細",
    "tgyj":"推廣佣金",
    "wwc": "未完成",
    "ywc": "已完成"
  },
  "assets":{
    "total":"資產折合",
    "avaiable":"可用",
    "conversion":"折合",
    "canuse":"可用",
    "yczc":"隱藏為0的資產"
  },
  "tipsNew":{
    "wjmmts": "通過驗證碼找回密碼",
    "qscpztp": "請上傳憑證圖片",
    "emailgsts": "輸入的郵箱不符合規則",
    "telgsts": "輸入的手機號碼格式有誤",
    "lcmmbyz": "兩次密碼輸入不一致",
    "zdsl": "最低數量 ",
    "sldydy": "數量大於等於",
    "zxtzsl": "最低數量 ",
    "ddz": "等待中",
    "xs": "小時",
    "min": "最小數量 ",
    "max": "最大數量 ",
    "yebz": "餘額不足",
    "qsrss": "請輸入手數",
    "zdss": "最低手數",
    "yjj": "已拒絕",
    "shz": "贖回中",
    "zwkfcz": "該幣種暫未開放充值",
    "jiaoge": "交割",
    "zhang": "漲",
    "die": "跌",
  },
  "status":{
    "statusText": ['失敗','等待處理','成功'],
  },
  "langNew2":{
    "zczgz": "總資產",
    "hgx": "合規性",
    "yszc": "隱私政策",
    "gywm": "關於我們",
    "zb": "AI 量化",
    "mnjy": "模擬交易",
    "xbzq": "新幣專區",
    "flzq": "福利專區",
    "cjmnzhcg": "創建模擬賬戶成功！",
    "wdzh": "我的賬戶",
    "yymnzhts": "已有虛擬賬號，請勿再次註冊",
    "tcmnzh": "退出模擬賬號",
    "mnzhgz": "模擬賬戶估值",
    "mnzh": "模擬賬戶",
    "ljdzsb": "連接地址失敗",
    "ysq": "已授權"
  },
  "c2c":{
    "bt": "P2P",
    "bt2": "P2P買幣",
    "cjdd": "建立訂單",
    "mblc": "買幣流程",
    "cjydd": "建立預訂單",
    "xmjfk": "付款給賣家",
    "tqhb": "提取您的數位貨幣",
    "ddzt": "訂單狀態",
    "wdys": "我們的優勢",
    "c1": "低廉的交易費用",
    "c2": "在我們的P2P買幣上,下單方以零手續費交易,我承諾在所有市場用最低的P2P交易費用",
    "c3": "多種付款方式",
    "c4": "點對點(P2P)交易允許賣家自由定義透明想要的付款方式,透過700多種付款方式,買賣加密貨幣包括銀行轉帳,現金。",
    "c5": "以您喜歡的價格交易",
    "c6": "以您喜歡的價格自由買賣加密貨幣,從現有報價中買賣,或建立交易廣告來設定您理想的價格",
    "wpp": "未符合",
    "ypp": "已符合",
    "ysx": "已失效",
    "ddh": "訂單號碼",
    "mrje": "買入金額",
    "mrbz": "買入幣種",
    "nssdgj": "國家",
    "qsrnssdgj": "請輸入國家",
    "fkrxm": "付款人姓名",
    "qsrfkrxm": "請輸入付款人姓名",
    "yx": "信箱",
    "qsryx": "請輸入信箱",
    "mmbz": "购买类型",
    "qxzmmbz": "请选择购买类型",
    "qxz": "請選擇",
    "fkfs": "付款方式",
    "qtxfkfs": "請填寫付款方式",
    "zh": "帳戶",
    "fb": "支付貨幣類型",
    "qtxfb": "請填寫支付幣種類型",
    "ngmdje": "您購買的金額",
    "qsrje": "請輸入金額",
    "wxts": "溫馨提示：",
    "dsh": "待審核",
    "ygq": "已過期",
    "jcwdwt": "P2P簡介",
    "tjpz": "提交憑證",
    "ckje": "匹配金額",
    "qsrckje": "請輸入匹配金額",
    "tjzzfb": "轉帳副本",
    "tjjzzm": "駕照正面",
    "tjjzfm": "駕照反面",
    "psts1": "拍攝時注意以下幾點",
    "psts2": "請注意圖片的邊框完整,字體清晰,亮度均勻",
    "psts3": "請勿上傳與姓名不符的證件照",
    "qsczzfb": "請上傳轉帳副本",
    "qscjzzm": "請上傳駕照正面",
    "qscjzfm": "請上傳駕照反面",
    "tj": "提交",
    "je": "金額",
    "ljtg": "立即託管",
    "sp": "了解DeFi",
    "xq": "詳情",
    "lxkfppdd": "聯絡客服配對訂單",
    "szgj": "所在國家",
    "qsrszgj": "請輸入所在國家",
    "fkyhmc": "付款銀行名稱",
    "qsrfkyhmc": "請輸入付款銀行名稱",
    "dianhui": "电汇/国际电汇",
    "ccsr": "此处输入"
  },
  "xyf":{
    "title": "信用分",
    "pgsj": "評估時間"
  },
  "bbjy":{
    "mr":"買入",
    "mc":"賣出",
    "mai":"買",
    "sell":"賣",
    "xj":"限價",
    "sj":"市價",
    "pk":"盤口",
    "jg":"價格",
    "sl":"數量",
    "mrl":"買入量",
    "ss":"數量",
    "mcl":"賣出量",
    "ky":"可用",
    "km":"可買",
    "ksell":"可賣",
    "jye":"交易額",
    "dqwt":"當前委托",
    "lswt":"歷史委托",
    "jj":"簡介",
    "wtzl":"委托總量",
    "wtjg":"委托價格",
    "ycjl":"已成交量",
    "cjjj":"成交均價",
    "cd":"撤單",
    "xd":"下單",
    "ywc":"已完成",
    "ycd":"已撤單",
    "wqcj":"完全成交",
    "zx":"自選",
    "scjg":"市場價格",
    "fhsj":"發行時間",
    "fhsl":"發行數量",
    "bps":"白皮書",
    "gw":"官網",
    "qx":"取消",
    "bbjy": "幣幣交易"
  },
  "hyjy":{
    "mai":"買",
    "sell":"賣",
    "kc":"開倉",
    "pc":"平倉",
    "cc":"持倉",
    "kp":"可平",
    "kpc":"可平空",
    "kcc":"可持倉",
    "kkd":"可開多",
    "kpd":"可平多",
    "kkk":"可開空",
    "xj":"限價",
    "sj":"市價",
    "xjwt":"限價委托",
    "sjwt":"市價委托",
    "pk":"盤口",
    "jg":"價格",
    "sl":"數量",
    "gg":"杠桿",
    "tzgg":"調整杠桿",
    "ggbs": "杠桿倍數",
    "mrl":"買入量",
    "ky":"可用",
    "jye":"交易額",
    "dqwt":"當前委托",
    "lswt":"歷史委托",
    "ptwt":"普通委托",
    "dqwtmr":"當前委托(買入)",
    "dqwtmc":"當前委托(賣出)",
    "hywt":"合約委托",
    "jj":"簡介",
    "wtzl":"委托總量",
    "wtjg":"委托價格",
    "ycjl":"已成交量",
    "cjjj":"成交均價",
    "cd":"撤單",
    "xd":"下單",
    "qbcd":"全部撤單",
    "wqcj":"完全成交",
    "ywc":"已完成",
    "ycd":"已撤單",
    "zx":"自選",
    "scjg":"市場價格",
    "fhsj":"發行時間",
    "fhsl":"發行數量",
    "bps":"白皮書",
    "gw":"官網",
    "mrzd":"買入做多",
    "mrpk":"買入平空",
    "mczk":"賣出做空",
    "mcpd":"賣出平多",
    "mrkdkz":"買入開多(看漲)",
    "mrpkkz":"買入平空(看漲)",
    "mckkkd":"賣出開空(看跌)",
    "mcpdkd":"賣出平多(看跌)",
    "yxhy":"永續合約",
    "dc":"多倉",
    "kcjj":"開倉均價(BUSDT)",
    "wsxyl":"未實現盈利(BUSDT)",
    "ygqpj":"預估強評價(BUSDT)",
    "syl":"收益率",
    "cwbzj":"倉位保證金(BUSDT)",
    "cw":"倉位(張)",
    "cwjz":"倉位價值(BUSDT)",
    "bzjl":"保證金率",
    "kpz":"可平(張)",
    "bdzs":"標的指數",
    "tzbzj":"調整保證金",
    "zyzs":"止盈止損",
    "zjbzj":"增加保證金",
    "jsbzj":"減少保證金",
    "tyhy":"體驗合約",
    "ccz":"持倉(張)",
    "cwbzjt":"倉位保證金(TBTC)",
    "zdzjbzj":"最多增加保證金(TBTC)",
    "zjbzjt":"增加保證金(TBTC)",
    "zhang":"數量",
    "qblx":"全部類型",
    "qb":"全部",
    "ccjg":"持倉價格",
    "ccsl":"持倉數量",
    "yk":"盈虧",
    "ccsj":"持倉時間",
    "zy":"止盈",
    "zs":"止損",
    "zje":"總金額",
    "kcs":"開倉數",
    "kcjg":"開倉價格",
    "ss":"手數",
    "hand":"1手 =",
    "qx":"取消",
    "qr":"確認"
  },
  "bbjyNew":{
    "jylx": "交易類型",
    "jyze": "交易總額"
  },
  "langNew3":{
    "bzxq": "搬磚詳情",
    "znbz": "AI量化智能搬磚",
    "apits": "無縫對接全球200+交易所Api",
    "jr": "加入",
    "gn": "功能",
    "lhjs": "派息量化介紹",
    "jqrts": "機器人是如何運作的？",
    "sctj": "市場統計",
    "scqk": "市場狀況",
    "jiaoge": "交割",
    "zhang": "漲",
    "die": "跌",
    "sz": "設定",
    "qbcp": "全部產品",
    "jrlh": "加入AI量化",
    "sywd": "0風險,收益穩定",
    "bzbz": "搬磚幣種"
  },
  "sztkmm":{
    "title":"設置交易密碼",
    "dlmm":"登錄密碼",
    "dlmmts":"請輸入登錄密碼",
    "xmm":"新密碼",
    "mmts":"密碼長度6位數字",
    "qrmm":"確認密碼",
    "qr":"確認",
    "qd": "確定",
    "sztkts": "提示：請到安全中心設置交易密碼"
  },
  "bzhl":{
    "title":"派息",
    "gz":"規則",
    "tgdd":"托管訂單",
    "zztgdzj":"正在托管的資金",
    "yjjrsy":"預估日收益",
    "ljsy":"總收入",
    "tgzdd":"托管中訂單",
    "cljxcp":"策略競選產品",
    "dbxe":"單筆限額",
    "rsyl":"日收益率",
    "zq":"周期",
    "qmr":"立即購買",
    "bbzhzc": "賬戶資產",
    "zcc": "總持倉(USDT)",
    "dd":"訂單",
    "buy":"買入",
    "jxcp":"精選產品",
    "ckdd":"查看訂單",
    "gd":"更多",
    "xzbzts": "簡單，安全。可選擇多種幣種進行派息",
    "qtbz": "其它幣種",
    "dj": "級",
    "cjwt": "常見問題",
    "ddsl": "訂單數量",
    "sl": "數量"
  },
  "bzhlgm":{
    "title":"搬磚獲利",
    "bzhld":"搬磚獲利得usdt",
    "qtzq":"USDT7天周期",
    "rsyl":"日收益率(%)",
    "lczq":"理財周期",
    "dbxe":"單筆限額 ",
    "pxsj":"派息時間",
    "mr":"每日",
    "dqfh":"到期返還",
    "tgzj":"托管資金",
    "tqsh":"提取贖回",
    "yjsy":"預計收益(USDT)",
    "kyzc":"可用資產(USDT)",
    "cpjs":"產品介紹",
    "tgje":"托管金額",
    "qsrtgje":"請輸入托管金額",
    "qb":"全部",
    "rm":"點這裡",
    "cpzq":"產品周期",
    "jxr":"計息日",
    "jiexr":"結息日",
    "yjdzr":"預計到賬日",
    "gz":"了解規則以及權益"
  },
  "bzhlwdtg":{
    "title":"訂單狀態",
    "tgz":"托管中",
    "ywc":"已完成",
    "ysh":"已贖回",
    "tgje":"托管金額/周期天數",
    "rsyl":"日收益率",
    "yhl":"已獲利/剩余天數",
    "xdsj":"下單時間",
    "sh":"贖回",
    "ddxq":"訂單詳情",
    "ddh":"訂單號",
    "syts": "剩餘天數",
    "ddztxq": "訂單狀態詳情"
  },
  "langNew4":{
    "kp": "開盤",
    "zuoshou": "昨收",
    "zg": "最高",
    "zd": "最低",
    "dqjg": "當前價格",
    "pcjg": "平倉價格",
    "gd": "掛單",
    "gdj": "掛單價",
    "gdjg": "掛單價格",
    "xfbzj": "需付保證金：",
    "ksrfw": "可輸入範圍：",
    "shou": "手",
    "fdjyk": "浮動淨盈虧",
    "pcsl": "平倉數量",
    "cx": "撤銷",
    "qrpc": "確認平倉",
    "sx": "篩選",
    "cz": "重置",
    "zdl": "知道了",
    "kccg": "開倉成功！",
    "xzfx": "選擇方向",
    "lx": "類型",
    "xgcc": "修改持倉",
    "szzyzs": "設置止盈止損",
    "szhb": "數字貨幣",
    "gjs": "貴金屬",
    "yy": "原油",
    "jy": "交易",
    "gp": "股票",
    "jmhb": "加密貨幣",
    "gdsj": "掛單時間",
    "gdsl": "掛單數量",
    "fs": "time"
   },
   "deals":{
    "issue_time":"發行時間",
    "issue_number": "發行數量",
    "white_book": "白皮書",
    "weburl": "官網",
    "video_url": "視頻介紹",
    "introduction":"簡介",
    "onhand":"1手等於",
    "position": "當前持倉",
    "leverorder":"杠桿下單",
    "leverposition":"杠桿持倉",
    "inputprice":"輸入價格",
    "inputmul":"輸入倍數",
    "selectmul":"選擇倍數",
    "onehand":"1手等於",
    "hand":"交易手數",
    "marketval":"合約市值",
    "bond":"保證金",
    "service":"服務費",
    "balance":"余額",
    "type":"類型",
    "risk":"風險率",
    "total":"持倉總盈虧：",
    "onekey":"一鍵平倉",
    "makemore":"(做多)",
    "makeless":"(做空)",
    "current":"當前委托",
    "all":"全部",
    "weing":"委托中",
    "tding":"交易中",
    "ping":"平倉中",
    "pied":"已平倉",
    "ceiled":"已撤單",
    "weprice":"委托價",
    "oprice":"開倉價",
    "nowprice":"當前價",
    "zyprice":"止盈價",
    "zsprice":"止損價",
    "canbond":"可用保證金",
    "optime":"開倉時間",
    "pgtime":"平倉時間",
    "znum":"折合數量",
    "gprice":"隔夜費",
    "pcang":"平倉",
    "revoke":"撤單",
    "fee":"手續費",
    "you":"以當前最優價格交易"
  },
  "zyzs":{
    "title":"止盈止損",
    "zy":"止盈",
    "zs":"止損",
    "qsrzyjg":"請輸入止盈價格",
    "qsrzsjg":"請輸入止損價格",
    "cfjglx":"觸發價格類型：",
    "zsjg":"指數價格",
    "scjg":"市場價格",
    "pcfs":"平倉方式：",
    "kpcw":"可平倉位",
    "qbcw":"全部倉位",
    "wxts":"溫馨提示：",
    "cont": "市場平倉，可能會因為行情波動劇烈等問題導致一定概率市價單下單失敗，無法成功止盈止損。",
    "qr":"確認"
  },
  "ssbt":{
    "ssbt":"稅收補貼",
    "ssnhm":"SSN號碼",
    "qsrssnhm":"請輸入SSN號碼",
    "idzmz":"ID正面照片",
    "qscidzmz":"請上傳ID正面照片",
    "dhfb":"電匯副本",
    "qscdhfb":"請上傳電匯副本",
    "srlyfb":"收入來源副本",
    "qscsrlyfb":"請上傳收入來源副本",
  },
  "newReg":{
    "sjh": "手機號",
    "yx": "郵箱",
    "yqm": "邀請碼",
    "yqm2": "邀請碼（可選）",
    "cjzh": "創建賬戶",
    "sysjhzyx": "使用手機號/電子郵箱註冊",
    "sj": "手機",
    "yhxy": "《用戶協議》",
    "yhxy2": "我已閱讀並同意《用戶協議》",
    "hmyzh":"還沒有賬號？",
    "qzc":"去註冊",
    "qbdl": "錢包登入",
    "qyqbfw": "請用錢包APP訪問",
    "dc": "登出"
  },
  "langNew5":{
    "dl":"登入",
    "ljdz":"連結錢包地址",
    "srdz":"輸入位址",
    "ljqq":"連線請求",
    "qq":"請求",
    "qb":"錢包",
    "ckyehhd":"查看您的餘額和活動",
    "qqjypz":"請求交易批准",
    "cro":"Cronos",
    "jj":"拒絕",
    "lj":"連線",
    }
}



// WEBPACK FOOTER //
// ./src/utils/lang/ft.js